export const getters = {
    getterBookmarks(state) {
        return state.bookmarks
    },
    getterBookmarksLength(state) {
        return state.bookmarks.length
    }
}
